export default {
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                  Trailer                     //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

    UI_SET_TRAILER_MOVIE:                       'UI_SET_TRAILER_MOVIE',
    UI_SET_YOUTUBE_COOKIE_CONFIRMATION:         'UI_SET_YOUTUBE_COOKIE_CONFIRMATION',

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //               accessibility                  //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    ACCESSIBILITY_SET_THEME:                    'ACCESSIBILITY_SET_THEME',        


    //this is just here so I can always place a comma after the new item when adding a new one
    NONE:                                   'NONE'
};  
